import React from 'react'

import template from './feature-3.twig'

import parse from 'html-react-parser'

import {
  Asset,
  ButtonOptions,
  ContentOptions,
  GridOptions,
  HeadlineOptions,
  LinkOptions,
  Offset,
  WorkshopsColors,
} from '@miro-site/components_utils'

type Feature3Item = {
  image?: Asset
  headline?: HeadlineOptions
  content?: ContentOptions
  link?: LinkOptions
  button?: ButtonOptions
}

export interface Feature3Props {
  background?: 'blue' | 'pink' | 'yellow' | WorkshopsColors
  items: Feature3Item[]
  offset?: Offset
  headline?: HeadlineOptions
  sub_headline?: ContentOptions
  top_button?: ButtonOptions
  button?: ButtonOptions
  button_text?: ContentOptions
  link?: LinkOptions
  grid?: GridOptions
  children?: React.ReactNode
}

const backgroundColors = {
  white: {
    background: '',
    headline: '',
    text: '',
    primaryButton: '',
    secondaryButton: 'transparent',
    link: '',
  },
  indigo: {
    background: 'indigo',
    headline: 'white',
    text: 'white',
    primaryButton: 'white',
    secondaryButton: 'white',
    link: 'white',
  },
  blue: {
    background: 'blue',
    headline: 'white',
    text: 'white',
    primaryButton: 'white',
    secondaryButton: 'white',
    link: 'white',
  },
  red: {
    background: 'red',
    headline: 'white',
    text: 'white',
    primaryButton: 'white',
    secondaryButton: 'white',
    link: 'white',
  },
  pink: {
    background: 'pink',
    headline: 'indigo',
    text: 'indigo',
    primaryButton: 'white',
    secondaryButton: 'white',
    link: 'indigo',
  },
  yellow: {
    background: 'yellow',
    headline: 'indigo',
    text: 'indigo',
    primaryButton: 'white',
    secondaryButton: 'white',
    link: 'indigo',
  },
  grey: {
    background: 'grey',
    headline: '',
    text: '',
    primaryButton: '',
    secondaryButton: 'transparent',
    link: '',
  },
}

const Feature3 = (props: Feature3Props): React.ReactElement => {
  return (
    <>
      {parse(
        template({
          ...props,
          backgroundColors,
          component_name: 'Feature Section',
          ctf_assets: 'images.ctfassets.net',
        }),
      )}
    </>
  )
}

export default Feature3
